import jhsLogo from '../images/jhsLogo.png';
import jpsLogo from "../images/jpsLogo.jpeg";

export const INSTITUTE_CONFIG = {
  1: {
    name: "JAIN HERITAGE SCHOOL",
    address1: "1598, Adjacent to Foundry Cluster, Dutch Industrial Estate,",
    address2: "Rani Channamma Nagar, Angol, Belagavi - 590 008",
    tel: "Tel: 0831-2483027, 2483025",
    logo: jhsLogo
  },
  2: {
    name: "JAIN PUBLIC SCHOOL",
    address1: "#Survey No. 19, at Peeranwadi, Machhe,",
    address2: "Belagavi - 590014",
    tel: "",
    logo: jpsLogo
  }
};

// Helper to get config by instituteId
export const getInstituteConfig = (instituteId) => {
  return INSTITUTE_CONFIG[Number(instituteId)];
};